import React, { useState } from "react";
import { Helmet } from "react-helmet";
import HeaderThree from "../header/HeaderThree";
import FooterTwo from "../footer/FooterTwo";
import CopyRightTwo from "../footer/CopyRightTwo";
import "../../assets/scss/carrier.scss";
import axios from "axios";
import { API_URL } from "../../config";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";


const ContactUs2 = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    position: "", // this will store the country
    coverLetter: "", // this will store the message
  });
  const [errors, setErrors] = useState({});
  const [submitStatus, setSubmitStatus] = useState("");

  const validateForm = () => {
    let tempErrors = {};
    let isValid = true;

    // Full Name validation
    if (!formData.fullName.trim()) {
      tempErrors.fullName = "Full name is required";
      isValid = false;
    } else if (formData.fullName.length < 2) {
      tempErrors.fullName = "Name must be at least 2 characters long";
      isValid = false;
    }

    // Email validation
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    if (!formData.email) {
      tempErrors.email = "Email is required";
      isValid = false;
    } else if (!emailRegex.test(formData.email)) {
      tempErrors.email = "Invalid email format";
      isValid = false;
    }

    // Phone validation
    const phoneRegex = /^[0-9]{10}$/;
    if (!formData.phone) {
      tempErrors.phone = "Phone number is required";
      isValid = false;
    } else if (!phoneRegex.test(formData.phone.replace(/[^0-9]/g, ""))) {
      tempErrors.phone = "Invalid phone number (10 digits required)";
      isValid = false;
    }

    // Country validation
    if (!formData.position.trim()) {
      tempErrors.position = "Country is required";
      isValid = false;
    }

    // Message validation
    if (!formData.coverLetter.trim()) {
      tempErrors.coverLetter = "Message is required";
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitStatus("");

    if (validateForm()) {
      try {
        const formPayload = new FormData();
        formPayload.append("name", formData.fullName);
        formPayload.append("email", formData.email);
        formPayload.append("phone", formData.phone);
        formPayload.append("country", formData.position);
        formPayload.append("message", formData.coverLetter);

        const response = await axios.post(
          `${API_URL}/api/enquery/newenquery`,
          formPayload,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );

        console.log("Form submitted successfully:", response.data);


        setFormData({
          fullName: "",
          email: "",
          phone: "",
          position: "",
          coverLetter: "",
          // resume: null,
        });

        setSubmitStatus("success");
      } catch (error) {
        console.error("Error submitting form:", error);
        setSubmitStatus("error");
        alert("Error submitting form. Please try again.");
      }
    } else {
      setSubmitStatus("error");
    }
  };

  return (
    <div className="main-page-wrapper">
      <Helmet>
        <title>Raiden Studios | Blockchain, DeFi, Gaming & VR Experts</title>
      </Helmet>
      <HeaderThree />
      <div className="carrier-section">
        <div className="container">
          <div className="hero-section text-center">
            <h1 className="hero-title" style={{ marginTop: 'revert' }}>
              Connect With Us
            </h1>

            <p className="hero-text">Tell us about your business goals and we will contact you Feel free to contact us if you need some help, consultation or you have some other question.</p>
          </div>

          <div className="career-form-container">
            <form className="career-form" onSubmit={handleSubmit}>
              <div className="form-grid">
                <div className="form-group">
                  <label className="form-label">Full Name</label>
                  <input
                    type="text"
                    name="fullName"
                    className={`form-input ${errors.fullName ? "error" : ""}`}
                    placeholder="Enter your name"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    required
                  />
                  {errors.fullName && (
                    <div className="error-message">{errors.fullName}</div>
                  )}
                </div>

                <div className="form-group">
                  <label className="form-label">Email Address</label>
                  <input
                    type="email"
                    name="email"
                    className={`form-input ${errors.email ? "error" : ""}`}
                    placeholder="Enter your email address"
                    value={formData.email}
                    onChange={handleInputChange}

                  />
                  {errors.email && (
                    <div className="error-message">{errors.email}</div>
                  )}
                </div>

                <div className="form-group">
                  <label className="form-label">Phone Number</label>
                  <PhoneInput
                    country={"in"}
                    value={formData.phone}
                    placeholder="Enter your phone number"
                    onChange={(value, data) =>
                      setFormData((prev) => ({
                        ...prev,
                        phoneNumber: value,
                        position: data?.name || prev.position,
                      }))
                    }
                    inputStyle={{
                      height: "55px",
                      paddingLeft: "60px",
                    }}
                    inputClass={`form-input ${errors.phone ? "error" : ""}`}
                  />
                  {errors.phone && (
                    <div className="error-message">{errors.phone}</div>
                  )}
                </div>

                <div className="form-group">
                  <label className="form-label">
                    Country
                  </label>
                  <input
                    name="position"
                    className={`form-input ${errors.position ? "error" : ""}`}
                    value={formData.position}
                    onChange={handleInputChange}

                  >

                  </input>
                  {errors.position && (
                    <div className="error-message">{errors.position}</div>
                  )}
                </div>
              </div>

              <div className="form-group full-width">
                <label className="form-label">Message</label>
                <textarea
                  name="coverLetter"
                  className={`form-input ${errors.coverLetter ? "error" : ""}`}
                  placeholder="How can we help you?"
                  value={formData.coverLetter}
                  onChange={handleInputChange}
                  rows="4"
                  required
                ></textarea>
                {errors.coverLetter && (
                  <div className="error-message">{errors.coverLetter}</div>
                )}
              </div>


              {submitStatus === "success" && (
                <div className="success-message">
                  Form submitted successfully! We'll get back to you soon.
                </div>
              )}

              {submitStatus === "error" && (
                <div className="error-message text-center">
                  Please fix the errors before submitting.
                </div>
              )}

              <div className="form-footer d-flex justify-content-center">
                <button type="submit" className="submit-button btn-gradient">
                  Send Message
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

    </div>
  );
};

export default ContactUs2;




